module.exports = __webpack_public_path__ + "static/media/csrd_report_img_1_2.c040f482.svg";